import React from 'react'
import useTrans from '../../../hooks/useTrans'
import { useRouter } from 'next/router'
import { Profile } from '../../atoms/NewIcons'
import { DropdownMenu } from '../../template/CataloghiTemplate/CataloghiTemplate'
import useAuth from '../../../hooks/useAuth'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'

const UtenteDropdown = () => {
  const { service_gift } = useSelector((state) => state?.servicegift)
  const { utente } = useSelector((state) => state?.utente)
  const { Logout } = useAuth()
  const t = useTrans()

  const options = useMemo(() => {
    return [
      {
        label: t('Il mio account'),
        type: 'link',
        link: '/myaccount',
        sg: true,
      },
      {
        label: t('I miei dati'),
        type: 'link',
        link: '/myaccount/profilo/personale',
        sg: true,
      },
      utente.permessi_frontend.find((value) => value === 'visualizzare_ordini') && {
        label: t('I miei ordini'),
        type: 'link',
        link: '/myaccount/documenti/ordini',
        sg: true,
      },
      // {
      //   label: t('Comunicazioni'),
      //   type: 'link',
      //   link: '/myaccount/comunicazioni/',
      // },
      // {
      //   label: t('Savati per dopo'),
      //   type: 'link',
      //   link: '/myaccount/salvati/',
      //   sg: true,
      // },
      utente?.is_fornitore && {
        label: t('Ritardi'),
        type: 'link',
        link: '/myaccount/fornitore/ritardi',
      },
      !utente?.is_fornitore && {
        label: t('Le mie offerte'),
        type: 'link',
        link: '/myaccount/offerte/salvate',
      },
      !utente?.is_fornitore && {
        label: t('Listini e condizioni'),
        type: 'link',
        link: '/myaccount/download/altridocumenti',
      },
      !utente?.is_fornitore && {
        label: t('Database'),
        type: 'link',
        link: '/myaccount/download/database',
      },
      !utente?.is_fornitore && {
        separatore: true,
        label: t('Ordine veloce'),
        type: 'link',
        link: '/strumenti-servizi/ordine-veloce',
      },
      !utente?.is_fornitore && {
        label: t('Ordini Taylor Made'),
        type: 'link',
        link: '/strumenti-servizi/tailor-made',
      },
      {
        label: t('Logout'),
        onClick: async () => await Logout(),
        sg: true,
        separatore: service_gift ? true : false,
      },
    ]
  }, [utente, service_gift])

  return (
    <DropdownMenu
      IconClass={'header__main__icon'}
      icon={<Profile width={26} />}
      Options={options.filter((item) => (service_gift ? item?.sg === true : item))}
      ariaLabel={t('Apri profilo')}
    />
  )
}

export default UtenteDropdown
